// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c8d61b {
  position: relative;
}
.e05a2f {
  display: flex;
  flex-direction: column;
}
.ed69d2 {
  position: absolute;
  padding: 0;
  list-style-type: none;
  background-color: var(--base-background-card);
  overflow: auto;
  max-height: 480px;
  min-width: 200px;
  max-width: 320px;
  width: max-content;
  z-index: 100;
  margin: 4px 0;
  border: 1px solid var(--base-decoration-secondary);
}
.aa3f49 {
  right: 0;
}
.fc694e {
  left: 0;
}
.b251d5 {
  bottom: 100%;
  right: 0;
}
.ef36be {
  bottom: 100%;
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/DropDown/DropDown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,6CAA6C;EAC7C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAEhB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kDAAkD;AACpD;AACA;EACE,QAAQ;AACV;AACA;EACE,OAAO;AACT;AACA;EACE,YAAY;EACZ,QAAQ;AACV;AACA;EACE,YAAY;AACd","sourcesContent":[".c8d61b {\n  position: relative;\n}\n.e05a2f {\n  display: flex;\n  flex-direction: column;\n}\n.ed69d2 {\n  position: absolute;\n  padding: 0;\n  list-style-type: none;\n  background-color: var(--base-background-card);\n  overflow: auto;\n  max-height: 480px;\n  min-width: 200px;\n  max-width: 320px;\n  width: -webkit-max-content;\n  width: max-content;\n  z-index: 100;\n  margin: 4px 0;\n  border: 1px solid var(--base-decoration-secondary);\n}\n.aa3f49 {\n  right: 0;\n}\n.fc694e {\n  left: 0;\n}\n.b251d5 {\n  bottom: 100%;\n  right: 0;\n}\n.ef36be {\n  bottom: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
